import { useMemo } from 'react';
import { BaseAPI, Configuration, FetchParams, HTTPHeaders } from 'eve-account-client';
import { useAuthState } from '@vis-auth/react';
import { useEnvironment } from '../context/Environment/EnvironmentContext';

export type Cancelable = { cancel: () => void };

/**
 * @todo re-instate when we upgrade React Query to 3.9.0+
 * @deprecated Do not use until React Query 3.9.0+
 */
/* istanbul ignore next */
export const cancelableApi = <T extends BaseAPI>(api: T): { api: T; cancel: () => void } => {
  const controller = new AbortController();
  const { signal } = controller;

  const newApi = api.withMiddleware({
    pre({ url, init }): Promise<FetchParams> {
      const newFetchParams: FetchParams = {
        url,
        init: { signal, ...init },
      };

      return Promise.resolve(newFetchParams);
    },
  });

  const cancel = (): void => controller.abort();

  return { api: newApi, cancel };
};

export const useConfiguration = (headers?: HTTPHeaders): Configuration => {
  const authState = useAuthState();
  const environment = useEnvironment();

  const configuration = useMemo(() => {
    return new Configuration({
      basePath: environment.EVE_ACCOUNT_URL,
      accessToken: authState.accessToken ?? '',
      headers,
    });
  }, [environment, authState, headers]);

  return configuration;
};
